import { useEffect, useState } from 'react';

import type { BrandVenues } from '../types';

export default function useGetDefaultVenueIds(brandsVenues: BrandVenues[] | null) {
  const [brandSelectedVenueIds, setBrandSelectedVenueIds] = useState<Record<string, string[]>>({});

  useEffect(() => {
    if (brandsVenues) {
      const defaultSelectedVenueIds: Record<string, string[]> = {};
      brandsVenues.map(brandVenues => {
        const brandId = brandVenues.brand.id;
        const { venues } = brandVenues;
        defaultSelectedVenueIds[brandId] = venues.map(venue => venue.id);
      });
      setBrandSelectedVenueIds(defaultSelectedVenueIds);
    }
  }, [brandsVenues]);

  return { brandSelectedVenueIds, setBrandSelectedVenueIds };
}
